import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

export type WidgetState = 'loading' | 'error' | 'empty' | 'ready';

@Component({
  selector: 'app-dashboard-widget-card',
  imports: [
    CommonModule
  ],
  templateUrl: './dashboard-widget-card.component.html',
  styles: ``,
})
export class DashboardWidgetCardComponent {
  @Input() title: string = '';
  @Input() subtitle?: string;
  @Input() iconBgClass: string = 'bg-blue-50 dark:bg-blue-900/20';
  @Input() state: WidgetState = 'loading';
  @Input() errorMessage: string = 'No se pudo cargar la información';
  @Input() emptyMessage: string = 'No hay datos para mostrar';
  @Input() drillDownLabel?: string;

  @Output() retry = new EventEmitter<void>();
  @Output() drillDown = new EventEmitter<void>();
}
